import { atomWithStorage } from 'jotai/utils';
export const diamondsAtom = atomWithStorage('wallet_diamonds', 0);
export const rechargeOverlayOpenAtom = atomWithStorage('recharge_overlay_open', false);
